import styled from 'styled-components';

import { mediaBreakpoint } from '../../utils/mediaBreakpoint';

type Props = {
    needPaddingTop?: boolean;
};

const InfoContainer = styled.div<Props>`
    div {
        ${mediaBreakpoint.down('md')} {
            ${({ theme }) => theme.TextStyles.span.Text14Left}
        }
    }
`;

export default InfoContainer;
